import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import type { SitePluginPlacementConfig } from '@wix/cli-app-definitions';
import { getSitePluginExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import {
  getExtensionRelativePaths,
  toPosix,
} from '../utils/extension-relative-paths.js';

const SITE_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/site-plugin'
);

export async function generateSitePlugin(
  projectFolder: string,
  route: string,
  name: string,
  placements: SitePluginPlacementConfig[]
) {
  const cwd = getSitePluginExtensionPath(projectFolder, route);
  const {
    relativePathToCodeFile,
    relativePathToConfigFile,
    relativePathToExtensionDir,
  } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: route,
    codeFileType: 'tsx',
  });

  const relativePathToSettingsFile = `./${toPosix(
    path.join(relativePathToExtensionDir, `${route}.panel.tsx`)
  )}`;

  const config = {
    id: randomUUID(),
    name,
    placements,
    element: relativePathToCodeFile,
    settings: relativePathToSettingsFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: SITE_PLUGIN_TEMPLATE,
    assetsOutputPath: 'public',
    assetsPrefix: route,
    projectFolder,
    cwd,
    data: {
      route,
      config,
    },
  });
}
